import React, { useState, useEffect } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import {
    Grid,
    Typography
} from '@deere/fuel-react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useAuthConfig } from "../helper";
import { useStyles } from "../styles/Filter";
import { getOptionSelectedByField } from '../utils/autocompleteUtils';

export const SupplierFilter = ({ expanded, onExpandClick, title, selectedSuppliers, onOptionsChange }) => {
    let authAxios = useAuthConfig();
    const classes = useStyles();
    const [options, setOptions] = useState([]);
    const [selectedSuppliersOptions, setSelectedSuppliersOptions]=useState([selectedSuppliers]);
    const [loading, setLoading] = useState(false);

    const getSuppliersList = async (value) => {
        setLoading(true)
        try {
            await authAxios.get(`/suppliers?queryString=${value}`).then(res => {
                setOptions(res.data)
                setLoading(false)
            })
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    };

    const handleChangeValues = (event, value) => {
        sessionStorage.setItem("selectedSuppliers", JSON.stringify(value));
        setSelectedSuppliersOptions(value);
        onOptionsChange(value)
    }

    useEffect(() => {
        setSelectedSuppliersOptions(sessionStorage["selectedSuppliers"] ? JSON.parse(sessionStorage.getItem("selectedSuppliers")) : selectedSuppliers);
    }, [selectedSuppliers]);

    return (
        <div className={classes.root}>
            <Accordion expanded={expanded === "supplier"}
                onChange={onExpandClick("supplier")}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{ content: classes.content, expanded: classes.expanded }}
                    expandIcon={<ExpandMoreIcon style={{ fontSize: '2rem' }} />}
                    aria-controls="supplier-status"
                    id="supplier-status"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>{title}</Typography>
                        </Grid>
                        {!expanded && (
                            <Grid item xs={12}>
                                {selectedSuppliersOptions ? selectedSuppliersOptions.map((data, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <CheckIcon style={{ color: "#367c2b", marginRight: "1rem" }}
                                                display="inline" />
                                            <Typography
                                                display="inline"
                                                key={data.supplierNumber}>{data.supplierName}</Typography>
                                            <br />
                                        </React.Fragment>)
                                }) : ""
                                }
                            </Grid>
                        )}
                    </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.root}>
                    <Autocomplete
                        multiple
                        size="small"
                        fullWidth
                        id="supplier-find"
                        options={options}
                        getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}`}
                        getOptionSelected={getOptionSelectedByField('supplierNumber')}
                        loading={loading}
                        value={selectedSuppliersOptions}
                        onChange={handleChangeValues}
                        onInputChange={(e, value) => {
                            if (value.length > 2)
                                getSuppliersList(value)
                        }}
                        renderInput={(params) => <TextField {...params} placeholder="Search Supplier name or number (enter 3 or  characters)" variant="outlined" />}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
